import {JOB_STATE_COMPLETE, JOB_STATE_PROCESSING} from "../const/job.const";

export default {
    props: {},
    data() {
        return {}
    },
    created: function () {
    },
    mounted: function () {
    },

    methods: {},
    computed: {
        id() {
            return this.$route.params.uuid;
        },
        currentJob() {
            return this.getJobById(this.id);
        },
        loading() {
            return this.getJobById(this.id).state === JOB_STATE_PROCESSING;
        },
        complete() {
            return this.getJobById(this.id).state === JOB_STATE_COMPLETE;
        }
    }
}
